import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const CardWrapperStyled = styled.div`
  border: 1px solid ${colors.neutral[400]};
  border-radius: 1rem;
  background-color: ${colors.neutral.white};
  padding: 2.4rem 3.2rem;

  &:not(:last-of-type) {
    margin-bottom: 2.4rem;
  }
`;

export const TitleInfoWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 3.2rem;
`;

export const ProductNameStyled = styled.h2`
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-weight: 700;
  letter-spacing: 0.03rem;
  margin: 0;
  display: inline-flex;
  align-items: flex-start;
  max-width: 75%;
`;

export const RatesBlockStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;
